import { Stack, useTheme } from "@mui/material";

import LeadSidebar from "@/modules/lead-page/new/components/sidebar/lead-sidebar";
import CustomerSidebarSkeleton from "@/modules/lead-page/new/components/sidebar/skeletons/customer-sidebar-skeleton";

const SidePanel = ({ isLoading }: { isLoading?: boolean }) => {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      spacing={theme.nawy.spacing.md}
      width="260px"
      height="100%"
      alignItems="center"
      borderRight={`1px solid ${theme.nawy.colors.semantic.border.secondary}`}
      borderRadius={`${theme.nawy.radius["2xl"]} 0 0 0`}
      bgcolor={theme.nawy.colors.semantic.layer.primary}
      sx={{
        overflow: "hidden",
      }}
    >
      {isLoading ? (
        <CustomerSidebarSkeleton />
      ) : (
        <LeadSidebar showActions={false} />
      )}
    </Stack>
  );
};

export default SidePanel;
